<template>
    <div class="article-list-section">
        <!-- 2 图文 -->
        <!-- -->
        <van-row v-if="dataItem" class="article-list-section-box" @click="go_article_detail(dataItem)">
            <van-col class="article-list-section-left">
                <van-image
                    v-if="dataItem.cover_img"
                    fit="cover"
                    class="article-list-content-imgs"
                    :src="dataItem.cover_img"
                    width="100%"
                    height="73"
                />
                <div class="article-list-section-left-top" v-if="dataItem.top == 1">
                    <img src="/static/v4/tag_top.svg" alt="" />
                </div>
                <div class="article-list-section-left-zl" v-else-if="dataItem.type == 2">
                    图文专栏
                    <img src="/static/img/course/icon_list_tag_column.svg" alt="" />
                </div>
                <!-- <div class="article-list-section-left-zl" v-else>
                    精彩图文
                </div> -->
                <!-- <div class="article-list-section-left-zl" v-else-if="dataItem.content.type == 3">
                    精彩图文
                </div> -->
            </van-col>

            <van-col class="article-list-content">
                <div class="article-list-title">
                    {{ dataItem.title | omitTitle }}
                </div>
                <div class="article-list-content-detail">
                    <div v-if="dataItem.type != 2">
                        <span>{{ dataItem.created_at.substr(0,11) }}</span>
                        <span>{{ dataItem.view_count }}人阅读</span>
                    </div>
                    <div v-else>已更新{{ dataItem.current_count }}节 | 共{{ dataItem.total_count }}节</div>
                </div>
            </van-col>
        </van-row>
    </div>
</template>

<script>
// import Interface from '@/util/interface'
import { formatDate } from '@/util/date.js'

export default {
    name: 'Article',
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        contentItem: {
            type: Object
        },
        wapperFn: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        omitTitle(value) {
            if (value.length > 18) {
                return value.slice(0, 18) + '...'
            } else {
                return value
            }
        },
        formatTime(value) {
            return formatDate(value, 'Y-M-D')
        }
    },
    methods: {
        go_article_detail(row) {
            if (!this.wapperFn) {
                this.$router.push({ name: 'article-detail', params: { id: row.id } })
            } else {
                this.$emit('goDetail', row)
            }
        }
        // getViewCount(row) {
        //     Interface.getData(
        //         "get",
        //         `/course-phase/api/recommend_v2/${row.id}/view`
        //     );
        // }
    }
}
</script>

<style lang="scss" scoped>
@import '@/components/variable.scss';

.article-list-section {
    background-color: #ffffff;
    border-radius: 10px 10px 0px 0px;
    margin-bottom: 17px;
    margin-top: 10px;

    .article-list-title {
        font-family: PingFangSC-Medium;
        font-size: 15px;
        font-weight: 500;
        text-align: justify;
        display: -webkit-box;
        .light {
            color: #0fb7ad;
        }
    }

    .article-list-content {
        text-align: left;
        position: relative;
        height: 80px;
        padding-left: 12px;
        // padding-right: 15px;

        &-desc {
            margin-top: 9px;
            font-size: 14px;
            color: $desc-color;
            text-align: justify;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-all;
            overflow: hidden;
        }

        &-detail {
            margin-top: 10px;
            width: 100%;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9d9d9d;
            letter-spacing: 0;
            .float-right {
                float: right;
                padding-right: $font16;
            }
            div {
                display: inline-block;
            }
        }

        &-img {
            width: 112px;
            height: 72px;
            border-radius: 6px;
            >>> .van-image__img {
                border-radius: 6px;
            }
            img {
                width: 112px;
                border-radius: 6px;
            }
        }
    }

    &-box {
        &:after {
            padding-top: 20px;
            width: 100%;
            height: 1px;
            border-bottom: 1px solid #e8e8e8;
            content: ' ';
            margin-bottom: 20px;
        }

        &:last-child:after {
            border: 0;
        }
        position: relative;
    }

    .article-list-section-left-zl {
        position: absolute;
        top: 0;
        left: 0;
        background: #10c3b5;
        border-radius: 6px 3px 3px 3px;
        font-family: PingFangSC-Medium;
        font-size: 10px;
        color: #ffffff;
        letter-spacing: 0;
        padding: 1px 6px;
        &.active {
            background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
            border-radius: 6px 3px 3px 3px;
        }
        img {
            width: 32px;
            height: 18px;
        }
    }

    .article-list-section-left {
        width: 130px;
        height: 73px;
        border-radius: 6px;
    }
    .article-list-content {
        width: 193px;
        height: 68px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .article-list-content-imgs {
        border-radius: 6px;
        /deep/ .van-image__img {
            width: 130px;
            height: 73px;
            border-radius: 6px;
        }
    }
    .article-list-section-left-zl {
        left: 4px;
        top: 4px;
        border-radius: 3px;
        background: linear-gradient(90deg, #faedd4 0%, #f0dbb6 100%);
        font-size: 11px;
        font-family: HarmonyOS_Sans_SC_Bold;
        color: #976730;
    }
    .article-list-section-left-top {
        position: absolute;
        top: 4px;
        left: 4px;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        img {
            width: 18px;
            height: 18px;
            border-radius: 3px;
        }
    }
    .article-list-section-box:after {
        padding-top: 0;
        margin-bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/medical-column/detail/article.vue